import styled from 'styled-components';

export const TagListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  padding: 2em 4em;

  @media (max-width: 720px) {
    padding: 0 1em 1em;
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const TagListBox = styled.div`
  width: 100%;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  &:hover {
    & img {
      transform: scale(1.1);
      filter: brightness(0.85);
    }
  }

  @media (min-width: 720px) {
    cursor: pointer;
  }

  & img {
    width: 100%;
    height: 100%;
    min-height: 203px;
    border-radius: 8px;
    filter: brightness(0.95);
    transition: all 0.4s ease;
  }

  & h2 {
    color: #fff;
    font-weight: 500;
    font-size: 15px;
    text-transform: uppercase;
    padding-left: 12px;
  }
`;

export const CardName = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 60px;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.8)
  );
  line-height: 60px;
  border-radius: 8px;
`;

export const CardCount = styled.div`
  position: absolute;
  bottom: 49px;
  min-width: 82px;
  left: 0;
  color: #fff;
  padding: 0px 19px;
  background-color: #0000007a;
  line-height: 30px;
  border-radius: 0 16px 16px 0;
  font-size: 16px;
`;

export const MoreTopicButton = styled.div`
  text-align: center;
  padding: 20px 4em 60px;

  @media (max-width: 720px) {
    padding: 36px 10px 36px;
  }
`;

export const ListImage = styled.img`
  background-image: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
